import React, { useState, useRef } from "react";
import emailjs from "emailjs-com";
import SEO from "../common/SEO";
import { FiArrowRight, FiCheck } from "react-icons/fi";
import HeaderTopBar from "../common/header/HeaderTopBar";
import HeaderOne from "../common/header/HeaderOne";
import FooterTwo from "../common/footer/FooterTwo";
import Copyright from "../common/footer/Copyright";
import ServiceTwo from "../elements/service/ServiceTwo";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import AboutTwo from "../elements/about/AboutTwo";
import Separator from "../elements/separator/Separator";
import AdvanceTab from "../elements/advancetab/AdvanceTab";
import CalltoActionFive from "../elements/calltoaction/CalltoActionFive";
import ReCAPTCHA from "react-google-recaptcha";

const RECAPTCHA_SITE_KEY = "6LeaOEosAAAAANUr0xNdbGkiKbMP-_kERUrzTFE2";

const FreeDigitalAudit = () => {
  const [message, setMessage] = useState("");
  const [captchaValue, setCaptchaValue] = useState(null);
  const recaptchaRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!captchaValue) {
      setMessage("❌ Please complete the reCAPTCHA.");
      return;
    }

    emailjs
      .sendForm(
        "service_7yyrafb",
        "template_nsldnyl",
        e.target,
        "mh2NzoQE6vH5s5-zI"
      )
      .then(
        (result) => {
          setMessage("✅ Thank you! Your form has been successfully submitted!");
          setTimeout(() => setMessage(""), 5000);
        },
        (error) => {
          console.error("Failed to send email:", error.text);
          setMessage("❌ Submission failed. Please try again.");
          setTimeout(() => setMessage(""), 5000);
        }
      );

    e.target.reset();
    setCaptchaValue(null);
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
    }
  };

  return (
    <>
      <SEO title="Corporate" />
      <main id="main-content" className="page-wrapper" aria-label="Main content">
        <div className="header-transparent-with-topbar">
          <HeaderTopBar />
          <HeaderOne
            btnStyle="btn-small btn-icon"
            HeaderSTyle="header-not-transparent"
          />
        </div>

        {/* Start Slider area */}
        <div
          className="slider-area slider-style-2 height-950 bg_image"
          data-black-overlay="2"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg/bg-image-55.png)`,
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="inner text-start">
                  <h4 className="subtitle">
                    <span className="theme-gradient">
                      DIGITAL CONSULTING AGENCY
                    </span>
                  </h4>
                  <h1 className="title display-one">Free Digital Audit</h1>

                  <ul className="list-icon">
                    <li>
                      <span className="icon">
                        <FiCheck />
                      </span>{" "}
                      Real-Time Tracking: Monitor your team’s progress on the go.
                    </li>
                    <li>
                      <span className="icon">
                        <FiCheck />
                      </span>{" "}
                      User-Friendly Interface: Intuitive design for smooth
                      navigation and quick inputs.
                    </li>
                    <li>
                      <span className="icon">
                        <FiCheck />
                      </span>{" "}
                      Enhanced Collaboration: Stay connected and productive
                      wherever your team is located.
                    </li>
                  </ul>

                  {/* Contact Form */}
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-8 col-md-6 col-12">
                        <form onSubmit={handleSubmit}>
                          <div className="form-group">
                            <div className="form-group mb-3">
                              <input
                                className="form-control"
                                type="text"
                                name="name"
                                placeholder="Your Full Name"
                                aria-label="Your Full Name"
                                required
                              />
                            </div>
                            <div className="form-group mb-3">
                              <input
                                className="form-control"
                                type="text"
                                name="organization"
                                placeholder="Your Organization Name      (Optional)"
                                aria-label="Your Organization Name (Optional)"
                              />
                            </div>
                            <div className="form-group mb-3">
                              <input
                                className="form-control"
                                type="number"
                                name="phone"
                                placeholder="Phone Number"
                                aria-label="Phone Number"
                                required
                              />
                            </div>
                            <div className="form-group mb-3">
                              <input
                                className="form-control"
                                type="email"
                                name="email"
                                placeholder="Your Email Address"
                                aria-label="Your Email Address"
                                required
                              />
                            </div>
                            <div className="form-group mb-3">
                              <input
                                className="form-control"
                                type="text"
                                name="subject"
                                placeholder="Inter Your Website Link"
                                aria-label="Enter Your Website Link"
                                required
                              />
                            </div>
                            <div className="form-group mb-3">
                              <input
                                className="form-control"
                                type="text"
                                name="message"
                                placeholder="Your Message"
                                aria-label="Your Message"
                              />
                            </div>
                           
                                <div className="form-group">
                              <ReCAPTCHA
                                  ref={recaptchaRef}
                                  sitekey={RECAPTCHA_SITE_KEY}
                                  onChange={(value) => setCaptchaValue(value)}
                              />
                              <input
                                  type="hidden"
                                  name="g-recaptcha-response"
                                  value={captchaValue || ""}
                              />
                                </div>

                            <button type="submit" className="btn-default btn-icon">
                              Submit{" "}
                              <i className="icon">
                                <FiArrowRight />
                              </i>
                            </button>
                          </div>
                          {message && (
                            <p className="mt-3" style={{ fontWeight: "bold" }}>
                              {message}
                            </p>
                          )}
                        </form>
                      </div>
                    </div>
                  </div>
                  {/* End Contact Form */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End Slider area */}

       

      

        <Separator />

        {/* Start Service Area */}
        <div className="rn-service-area rn-section-gap">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <SectionTitle
                  textAlign="text-center"
                  radiusRounded=""
                  subtitle="What we can do for you"
                  title="Website accessibility compliance ensures equal access for everyone."
                  description="Laws mandate that websites be accessible to individuals with disabilities. An accessible website provides a secure experience for all users and helps avoid legal risks."
                />
              </div>
            </div>
            <ServiceTwo cardStyle="card-style-1" textAlign="text-start" />
          </div>
        </div>
        {/* End Service Area */}

        <Separator />
        <AboutTwo />
        <Separator />

     

      

        <AdvanceTab />

        {/* Start Call To Action Area */}
        <div className="rwt-callto-action-area rn-section-gapBottom">
          <div className="wrapper">
            <CalltoActionFive />
          </div>
        </div>
        {/* End Call To Action Area */}

        <FooterTwo />
        <Copyright />
      </main>
    </>
  );
};

export default FreeDigitalAudit;
